interface PulseDotProps {
  color?: 'green' | 'amber' | 'red' | 'blue';
  size?: 'sm' | 'md';
}

const colorMap = {
  green: '#2D7D5F',
  amber: '#C77D3E',
  red: '#B94A3C',
  blue: '#5B7BA3',
};

const PulseDot = ({ color = 'green', size = 'sm' }: PulseDotProps) => {
  const s = size === 'sm' ? 8 : 10;

  return (
    <span
      className="inline-block rounded-full gentle-pulse flex-shrink-0"
      style={{ width: s, height: s, backgroundColor: colorMap[color] }}
    />
  );
};

export default PulseDot;
